var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeedSpace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2767_33201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99975 -0.000183105C15.5138 -0.000183105 20 4.48604 20 9.99957C20 15.5136 15.5138 19.9998 9.99975 19.9998C4.48622 19.9998 0 15.5136 0 9.99957C0 4.48604 4.48622 -0.000183105 9.99975 -0.000183105ZM18.9475 9.99957C18.9475 5.06581 14.9335 1.05229 9.99975 1.05229C5.066 1.05229 1.05248 5.06581 1.05248 9.99957C1.05248 14.9333 5.066 18.9473 9.99975 18.9473C14.9335 18.9473 18.9475 14.9333 18.9475 9.99957Z",
    fill: "#E5EAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6853 6.84167V8.94711C13.6853 9.23774 13.4494 9.47359 13.1588 9.47359C12.8687 9.47359 12.6328 9.23774 12.6328 8.94711V6.84167C12.6328 6.55153 12.8687 6.31567 13.1588 6.31567C13.4494 6.31567 13.6853 6.55153 13.6853 6.84167Z",
    fill: "#E5EAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99948 12.6317C11.1807 12.6317 12.1049 13.3254 12.1049 14.2106C12.1049 15.0958 11.1807 15.7896 9.99948 15.7896C8.81872 15.7896 7.89453 15.0958 7.89453 14.2106C7.89453 13.3254 8.81872 12.6317 9.99948 12.6317ZM11.0525 14.2106C11.0525 13.9955 10.6419 13.6841 9.99948 13.6841C9.35754 13.6841 8.94701 13.9955 8.94701 14.2106C8.94701 14.4253 9.35754 14.7366 9.99948 14.7366C10.6419 14.7366 11.0525 14.4253 11.0525 14.2106Z",
    fill: "#E5EAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.36888 6.84173V8.94717C7.36888 9.2378 7.13302 9.47366 6.8424 9.47366C6.55226 9.47366 6.31641 9.2378 6.31641 8.94717V6.84173C6.31641 6.55159 6.55226 6.31573 6.8424 6.31573C7.13302 6.31573 7.36888 6.55159 7.36888 6.84173Z",
    fill: "#E5EAF9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2767_33201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedSpace);
export default __webpack_public_path__ + "static/media/needSpace.3cdda25177556c4b71252fe0f4ef6510.svg";
export { ForwardRef as ReactComponent };